<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
      <p class="title is-1" align="center">Inbox</p><br><br>

        <!-- Create messages table -->
        <div class="columns is-centered">
          <div class="column is-two-thirds">
            <div class="card">
              <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Subject</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="m in messages.slice().reverse()">
                    <td v-if="!m.dismissed">{{ m.date }}</td>
                    <td v-if="!m.dismissed">{{ m.subject }}</td>
                    <td v-if="!m.dismissed">
                      <button @click="showModal(m.key, m.date, m.subject, m.message)"
                      class="button is-small">Open</button>
                    </td>
                    <td v-if="!m.dismissed">
                      <button @click="dismissMessage(m)" class="button is-small">Dismiss</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div><br><br>
            <!-- Feedback button routes to KNOSIS contact form -->
            <a href="http://knosishealth.com/contact.html" class="button is-fullwidth">Feedback</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Declare message modal details -->
    <message-modal
      v-show="showMessageModal"
      @close="closeMessageModal"
    ></message-modal>
  </div>
</template>

<script>
  import * as firebase from 'firebase'
  import messageModal from './messageModal.vue'

  export default {
    components: {
      'message-modal': messageModal
    },
    data() {
      return {
        showMessageModal: false,
        currentMessage: {
          key: '',
          date: '',
          subject: '',
          message: '',
          dismissed: '',
        },
        text: '',
        messages: []
      }
    },
    mounted () {
      this.refreshMessages();
    },

    methods: {

      //If T&C not accepted deliver message to user
      updateMessages(){
        firebase.database().ref('users').
        child(this.$store.getters.user.id).
        child('messages').set(this.messages)
      },
      refreshMessages(){
        this.messages = [];
         firebase.database().ref('users').child(this.$store.getters.user.id).child('messages').once('value')
          .then((data) => {
            const obj = data.val()
            for (let key in obj) {
              this.messages.push({
                key: key,
                date: obj[key].date,
                subject: obj[key].subject,
                message: obj[key].message,
                dismissed: obj[key].dismissed,
              })
            }
          })
      },
      dismissMessage(message){
        firebase.database().ref('users').
        child(this.$store.getters.user.id).
        child('messages').child(message.key).update({
          dismissed:true,
        })
        this.refreshMessages();
      },
      addMessage(){
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();

        if(dd<10) {
            dd = '0'+dd
        }

        if(mm<10) {
            mm = '0'+mm
        }

        today = mm + '/' + dd + '/' + yyyy;
        var newMessage = {
          date: today,
          message: this.text
        }
        this.messages.push(newMessage);

      },
      showModal(k, d, s, m) {
        this.currentMessage.key = k
        this.currentMessage.date = d
        this.currentMessage.subject = s;
        this.currentMessage.message = m;
        this.$root.$emit('currentMessage', this.currentMessage);
        this.showMessageModal=true;
      },
      closeMessageModal(){
        this.showMessageModal = false;
        this.refreshMessages();
      }

    }
  }
</script>

<style scoped>
thead th {
  color: white;
}
a.button {
  background-color: purple;
  color: white;
  font-weight: 400;
  font-size: 14px;
  height: 36px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: none;
  -o-transition: all 0.218s;
  -moz-transition: all 0.218s;
  -webkit-transition: all 0.218s;
  transition: all 0.218s;
}
a.button:hover {
  background-color: white;
  color: purple;
}
</style>



// WEBPACK FOOTER //
// src/components/Inbox/Inbox.vue